import { forwardRef, type ComponentProps } from 'react';
import { CommonHTMLInputAttributes } from '@frontend/types';
import { EmailInput } from '../../atoms/email-input.component';
import { FieldLayoutWithAction } from '../../layouts/field-layout-with-action';
import type { BasicFormFieldProps, ExtraFieldProps, FieldActionProps } from '../../layouts/types';

type Props = BasicFormFieldProps<'email'> &
  ExtraFieldProps &
  FieldActionProps &
  Omit<CommonHTMLInputAttributes, 'onChange' | 'value' | 'type'>;

export const EmailField = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <FieldLayoutWithAction
    {...props}
    //TODO: this might be able to be improved. But this type cast just makes sure the field prop is any of the correct field types
    field={EmailInput as ComponentProps<typeof FieldLayoutWithAction>['field']}
    ref={ref}
  />
));

EmailField.displayName = 'EmailField';
